/**
 * При отрисовке окна логина без видимых кнопок на верхней панели инструментов
 * кешируется неправильная ширина этих кнопок
 */
var renderLoginWindow = LoginView.prototype.renderLoginWindow;
LoginView.prototype.renderLoginWindow = function() {
    renderLoginWindow.apply(this, arguments);
    delete Ext.layout.component.Auto.prototype.widthCache['tool-default'];
};
